export default "__VITE_ASSET__ot_Vanfv__"